import img1 from '../allImage/main-section-1/background.jpg'
import img2 from '../allImage/section-2/2.jpg'
import img3 from '../allImage/logo/logo.png'
import img4 from '../allImage/section-3/1.jpeg'
import img5 from '../allImage/section-3/profile/1.jpeg'
import img6 from '../allImage/section-3/profile/2.jpg'
import img7 from '../allImage/section-3/profile/3.jpg'
const img=[img1,img2,img3,img4,img5,img6,img7]
export default img